<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert dense prominent shaped text :type="alertType">
          {{ message }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "MessageAlert",
  props: {
    message: {
      type: String,
      required: true,
    },
    alertType: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
>>> .info--text {
  color: #838383 !important;
  caret-color: #838383 !important;
}
</style>
